import React, {Component} from 'react';
import YouTube from 'react-youtube';
import {isMobile} from 'react-device-detect';

export default class Home extends Component {

  renderMailChimp() {
    return (
        <div id="mc_embed_signup">
          <form action="https://thefpsgame.us19.list-manage.com/subscribe/post?u=f4468c7c55da70536ba843535&amp;id=90120ec79f" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
            <div id="mc_embed_signup_scroll">
              <label for="mce-EMAIL">Join our mailing list and get updates on playtests, releases, and more!</label>
              <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="email address" required/>
              <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true">
                <input type="text" name="b_f4468c7c55da70536ba843535_90120ec79f" tabindex="-1" value=""/>
              </div>
              <div class="clear">
                <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button"/>
              </div>
            </div>
          </form>
        </div>);
  }

  renderSteam() {
    return (<iframe src="https://store.steampowered.com/widget/1089710/" frameborder="0" width="646" height="190" title="fps_steam"></iframe>);
  }

  render() {
    const opts = {
      height: isMobile ? window.height : 390,
      width: isMobile ? window.width : 640,
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 0
      }
    };

    const descripClass = isMobile ? "homeDescriptionMobile" : "homeDescription";

    return (
      <div>
        <div className={descripClass}>
          <h2>The postal delivery party game you never knew you needed!</h2>
          <br/>
          <p className="homeDescription">Fruit Postal Service is a party racing game for up to four players.
          Pick one of the employees of the Fruit Postal Service and use your fruity powers to deliver the mail.
          Whether you pick Walter Melon, Professor Sherry, Bandana-nana or Jack Apple, you'll find yourself racing against the other drivers (and the clock!) to deliver the mail.
          Grab those keys and start up your engines and show everyone else why you deserve to be employee of the month!
          <br/><br/>
          Fruit Postal Service is a labor of fruity love coming to PC on Steam June 2019.
          <br/><br/>
          {this.renderMailChimp()}
          {this.renderSteam()}
          </p>
        </div>
        <div className="trailerVid">
          <YouTube
            videoId={'uji-hNP1GqE'}
            opts={opts}/>
        </div>
      </div>
    )
  }
}
